import React, { useState } from "react";
import sliderImage from "../../../assets/slider.svg";  // Adjust path according to your structure
import "./styles.css";

const images = [
  sliderImage,
  sliderImage,
  sliderImage,
  sliderImage,
];

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="slider-container">
      <div className="slider">
        <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} />
      </div>

      <div className="dots">
        {images.map((_, index) => (
          <div
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
